var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout_DuelChallenge_Actions',[_c('Button_Share',{attrs:{"text":_vm.$t('general.share-with-friend')},nativeOn:{"click":function($event){return _vm.onShareClick($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }